export enum RolloverTypeEnum {
  COEFFICIENT = 'COEFFICIENT',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT',
}
